import React from 'react';
import { Checkbox } from '@carbon/react';
import './LabelCheckboxGroup.css'; // なければ既存の .check-wrap / .check-item を流用

export default function LabelCheckboxGroup({
  allLabels = [],
  selectedLabels = [],
  onToggle = () => {},
  idPrefix = 'lbl',
}) {
  return (
    <div className="check-wrap">
      {allLabels.map((label) => (
        <div className="check-item" key={`${idPrefix}-${label}`}>
          <Checkbox
            id={`${idPrefix}-${label}`}
            labelText={label}
            checked={selectedLabels.includes(label)}
            onChange={() => onToggle(label)}
          />
        </div>
      ))}
    </div>
  );
}
